import {
  type DashRouteType,
  URL_APP_ADMIN,
  URL_PUBLIC,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/routing'

const URL_ADMIN_PARTNER_MANAGEMENT = `${URL_APP_ADMIN}/partner-management`
const URL_ADMIN_PARTNER_MANAGEMENT_LIST = `${URL_ADMIN_PARTNER_MANAGEMENT}/list`
// @hygen:inject admin-urls

export type DashRouteSet =
  | DashRouteType<'app-admin-partner-management'>
  | DashRouteType<'app-admin-partner-management-list'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'app-admin-partner-management': URL_ADMIN_PARTNER_MANAGEMENT,
  'app-admin-partner-management-list': URL_ADMIN_PARTNER_MANAGEMENT_LIST,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
